import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Search, Target, Map } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const hStyle: React.CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontWeight: 800,
  color: 'var(--bw-dark)',
  letterSpacing: '-0.025em',
  lineHeight: 1.15,
};

const highlights = [
  { Icon: Search, title: 'Where AI actually fits', desc: 'A clear-eyed look at your operations to find where AI creates real leverage — not where it sounds impressive.' },
  { Icon: Target, title: 'No buzzwords, no hype', desc: 'Recommendations grounded in your business, not whatever tool is trending this month.' },
  { Icon: Map, title: 'A roadmap you can act on', desc: 'Walk away knowing exactly what to build first, and why.' },
];

const AIAssessments = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--bw-white)' }}>
      <Helmet>
        <title>AI Assessments — BrightWings</title>
        <meta name="description" content="A focused evaluation of where AI can move the needle in your business — and where it can't. Clear decisions first." />
        <link rel="canonical" href="https://brightwings.io/ai-assessments" />
      </Helmet>
      <Navigation />

      <section className="bw-hero">
        <div className="max-w-5xl mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <div className="bw-eyebrow-pill">Coming Soon</div>
            <h1 style={{ ...hStyle, fontSize: 'clamp(32px, 5vw, 62px)', marginBottom: '20px' }}>
              Know exactly where AI can move the needle in{' '}
              <em style={{ fontStyle: 'normal', color: 'var(--bw-blue)' }}>your business.</em>
            </h1>
            <p style={{ fontSize: 'clamp(16px, 2vw, 19px)', color: 'var(--bw-text-mid)', lineHeight: 1.7, maxWidth: '540px', margin: '0 auto 32px' }}>
              A focused assessment of where AI creates real value in your operations — and where it doesn't. Full details coming soon.
            </p>
            <Link to="/contact" className="bw-btn-primary" style={{ display: 'inline-flex', textDecoration: 'none' }}>
              Start a conversation
            </Link>
          </div>
        </div>
      </section>

      <section className="bw-section-surface">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {highlights.map(({ Icon, title, desc }, i) => (
              <div key={i} className="bw-card">
                <div className="bw-card-body">
                  <div className="w-11 h-11 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'var(--bw-blue-light)' }}>
                    <Icon size={20} color="var(--bw-blue)" />
                  </div>
                  <p style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--bw-dark)', fontSize: '17px', marginBottom: '8px' }}>{title}</p>
                  <p style={{ fontSize: '15px', color: 'var(--bw-text-mid)', lineHeight: 1.6 }}>{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AIAssessments;
